// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ConnectedApplicationSession } from '@/account/api/get-connected-applications';
import { DateTime } from 'luxon';

/** Names a session by the device it named, or else the system it was signed in from. */
export function toSessionTitle(session: ConnectedApplicationSession) {
  return session.deviceId ?? session.signInOperatingSystem ?? 'Unknown device';
}

/** Says when and where a session was signed in and last used. */
export function toSessionSubtitle(session: ConnectedApplicationSession) {
  const signedIn = [
    `Signed in ${session.signedInAt.toLocaleString(DateTime.DATETIME_MED)}`,
  ];

  // A session titled by its device still names the system it was signed in from.
  if (session.deviceId !== null && session.signInOperatingSystem !== null) {
    signedIn.push(`on ${session.signInOperatingSystem}`);
  }

  if (session.signInIpAddress !== null) {
    signedIn.push(`from ${session.signInIpAddress}`);
  }

  const lastUsed = [
    `Last used ${session.lastUsedAt.toLocaleString(DateTime.DATETIME_MED)}`,
  ];
  if (session.lastUsedIpAddress !== null) {
    lastUsed.push(`from ${session.lastUsedIpAddress}`);
  }

  return `${signedIn.join(' ')} · ${lastUsed.join(' ')}`;
}
